<div mat-dialog-title class="qr-export-title">
  <div class="title-icon"><mat-icon>qr_code_2</mat-icon></div>
  <div>
    <h2>{{(tridys.length === 1 ? 'tridys.qrExport.singleTitle' : 'tridys.qrExport.multipleTitle') | translate}}</h2>
    <p>{{tridys.length}} {{(tridys.length === 1 ? 'tridys.qrExport.selectedOne' : 'tridys.qrExport.selectedMany') | translate}}</p>
  </div>
</div>

<mat-dialog-content class="qr-export-content">
  <div class="form-grid basic-grid">
    <mat-form-field appearance="outline">
      <mat-label>{{'tridys.qrExport.fileType' | translate}}</mat-label>
      <mat-select [(ngModel)]="qrFormat" [disabled]="exporting">
        <mat-option value="cmyk-pdf">CMYK PDF</mat-option>
        <mat-option value="cmyk-jpeg">CMYK JPEG</mat-option>
        <mat-option value="png">PNG</mat-option>
        <mat-option value="jpeg">JPEG</mat-option>
      </mat-select>
      <button mat-icon-button matSuffix type="button" class="setting-info-button" [matTooltip]="'tridys.qrExport.fileTypeHint' | translate" [attr.aria-label]="'tridys.qrExport.fileTypeHint' | translate"><mat-icon>info_outline</mat-icon></button>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{'tridys.qrExport.errorCorrection' | translate}}</mat-label>
      <mat-select [(ngModel)]="qrErrorCorrection" [disabled]="exporting">
        <mat-option value="L">{{'tridys.qrExport.low' | translate}}</mat-option>
        <mat-option value="M">{{'tridys.qrExport.medium' | translate}}</mat-option>
        <mat-option value="Q">{{'tridys.qrExport.quartile' | translate}}</mat-option>
        <mat-option value="H">{{'tridys.qrExport.high' | translate}}</mat-option>
      </mat-select>
      <button mat-icon-button matSuffix type="button" class="setting-info-button" [matTooltip]="'tridys.qrExport.errorCorrectionHint' | translate" [attr.aria-label]="'tridys.qrExport.errorCorrectionHint' | translate"><mat-icon>info_outline</mat-icon></button>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{'tridys.qrExport.qrSizeMm' | translate}}</mat-label>
      <input matInput type="number" min="10" max="1000" [(ngModel)]="qrPrintSizeMm" [disabled]="exporting">
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filename-template-field">
    <mat-label>{{'tridys.qrExport.fileNamePattern' | translate}}</mat-label>
    <input matInput #filenameInput [(ngModel)]="filenameTemplate" [disabled]="exporting" [placeholder]="'{{tridyId}}'">
    <span matTextSuffix class="filename-extension">.{{filenameExtension}}</span>
    <mat-hint>{{'tridys.qrExport.fileNamePatternHint' | translate}}</mat-hint>
  </mat-form-field>
  @if (filenameTemplateError) { <p class="filename-template-error">{{'tridys.qrExport.invalidPlaceholder' | translate}}</p> }
  <div class="filename-placeholder-row my-3">
    <span class="filename-placeholder-label">{{'tridys.qrExport.insert' | translate}}</span>
    <div class="filename-chips" [attr.aria-label]="'tridys.qrExport.commonPlaceholders' | translate">
      <button type="button" class="filename-chip" [disabled]="exporting" (click)="insertFilenameKey('tridyId', filenameInput)">{{'tridys.qrExport.id' | translate}}</button>
      @for (key of dateFilenameKeys; track key) {
        <button type="button" class="filename-chip" [disabled]="exporting" (click)="insertFilenameKey(key, filenameInput)">{{key}}</button>
      }
    </div>
    @if (qrFilenameKeys.length) {
      <button type="button" class="filename-key-trigger" [matMenuTriggerFor]="filenameKeysMenu" [disabled]="exporting">{{'tridys.qrExport.dataStructure' | translate}} <mat-icon>arrow_drop_down</mat-icon></button>
      <mat-menu #filenameKeysMenu="matMenu" class="filename-keys-menu">
        @for (key of qrFilenameKeys; track key) {
          <button mat-menu-item [matTooltip]="key" [attr.aria-label]="key" (click)="insertFilenameKey(key, filenameInput)">
            <span class="filename-key-option"><strong>{{filenameKeyLabel(key)}}</strong>@if (filenameKeyParent(key)) { <small>{{filenameKeyParent(key)}}</small> }</span>
          </button>
        }
      </mat-menu>
    }
  </div>

  <mat-expansion-panel class="advanced-panel">
    <mat-expansion-panel-header>
      <mat-panel-title><mat-icon>tune</mat-icon> {{'tridys.qrExport.advancedOptions' | translate}}</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="form-grid advanced-grid">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{'tridys.qrExport.quietZone' | translate}}</mat-label>
        <input matInput type="number" min="4" max="32" [(ngModel)]="qrQuietZoneModules" [disabled]="exporting">
        <button mat-icon-button matSuffix type="button" class="setting-info-button" [matTooltip]="'tridys.qrExport.quietZoneInfo' | translate" [attr.aria-label]="'tridys.qrExport.quietZoneInfo' | translate"><mat-icon>info_outline</mat-icon></button>
        <mat-hint>{{'tridys.qrExport.quietZoneHint' | translate}}</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{'tridys.qrExport.resolutionDpi' | translate}}</mat-label>
        <input matInput type="number" min="72" max="2400" [(ngModel)]="qrDpi" [disabled]="exporting">
        <mat-hint>{{'tridys.qrExport.resolutionDpiHint' | translate}}</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{'tridys.qrExport.jpegQuality' | translate}}</mat-label>
        <input matInput type="number" min="1" max="100" [(ngModel)]="qrJpegQuality" [disabled]="exporting">
        <mat-hint>{{'tridys.qrExport.jpegQualityHint' | translate}}</mat-hint>
      </mat-form-field>
    </div>
  </mat-expansion-panel>

  @if (exporting) {
    <div class="export-progress" aria-live="polite">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <strong>{{'tridys.qrExport.preparing' | translate}}</strong>
        <span>{{progress.completed}} / {{progress.total}}</span>
      </div>
      <mat-progress-bar mode="determinate" [value]="exportPercent"></mat-progress-bar>
      <small>{{exportPercent}}% · {{'tridys.qrExport.keepOpen' | translate}}</small>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button [disabled]="exporting" (click)="close()">{{'cancel' | translate}}</button>
  <button mat-button class="orange-button" [disabled]="!tridys.length || exporting || !!filenameTemplateError" (click)="download()"><mat-icon>download</mat-icon> {{'tridys.qrExport.download' | translate}}</button>
</mat-dialog-actions>
